module.exports = "/_next/static/images/cbdc34e53615e85c8e5d4f8c286898be-filter.svg.webp";